import request from '../helpers/request';
import { ownedGiftCardsAPI, bindGiftCardAPI } from '../helpers/api';

export const getOwnedGiftCards = theatreId => request(ownedGiftCardsAPI({ theatreId }));
export const bindGiftCard = number => request(bindGiftCardAPI(number), 'POST');
